/**
 * Persian names of the audit actions the backend writes (AC §19.2.3). An action missing here gets a
 * neutral name; its code stays in the event details.
 */
export const AUDIT_ACTION_LABELS: Readonly<Record<string, string>> = {
  APPROVAL_APPROVED: 'تأیید درخواست',
  APPROVAL_CANCELLED: 'لغو درخواست تأیید',
  APPROVAL_EXPIRED: 'انقضای درخواست تأیید',
  APPROVAL_REJECTED: 'رد درخواست',
  APPROVAL_REQUESTED: 'ثبت درخواست تأیید',
  BRANCH_DEACTIVATED: 'غیرفعال‌سازی شعبه',
  BRANCH_REQUEST_APPROVED: 'اعمال درخواست شعبه',
  BRANCH_REQUEST_CREATED: 'ثبت درخواست شعبه',
  BRANCH_REQUEST_REJECTED: 'رد درخواست شعبه',
  BUYER_CLOSED: 'بستن حساب خریدار',
  BUYER_CREDIT_CHANGED: 'تغییر اعتبار خریدار',
  BUYER_IDENTITY_REJECTED: 'رد مدرک هویت خریدار',
  BUYER_IDENTITY_VERIFIED: 'تأیید هویت خریدار',
  // K5 (retired by D-118): rows already written keep their name.
  BUYER_PHYSICAL_CARDS_EXPORTED: 'خروجی کارت‌های فیزیکی',
  BUYER_PHYSICAL_CARD_PRINT_BATCH_CREATED: 'ساخت چاپ کارت',
  BUYER_PHYSICAL_CARD_PRINT_BATCH_DOWNLOADED: 'دریافت فایل چاپ کارت',
  BUYER_PHYSICAL_CARD_BLOCKED: 'مسدودسازی کارت فیزیکی',
  BUYER_PHYSICAL_CARD_ISSUED: 'صدور کارت فیزیکی',
  BUYER_PHYSICAL_CARD_REISSUED: 'صدور مجدد کارت فیزیکی',
  BUYER_PHYSICAL_CARD_STATUS_CHANGED: 'تغییر وضعیت کارت فیزیکی',
  BUYER_PHYSICAL_CARD_UNBLOCKED: 'رفع مسدودی کارت فیزیکی',
  BUYER_PROVISIONED: 'ثبت خریدار',
  BUYER_PURCHASING_BLOCKED: 'توقف خرید خریدار',
  BUYER_REACTIVATED: 'فعال‌سازی دوبارهٔ خریدار',
  BUYER_RESTRICTION_CREATED: 'ثبت محدودیت خریدار',
  BUYER_RESTRICTION_RELEASED: 'رفع محدودیت خریدار',
  BUYER_STATUS_CHANGED: 'تغییر وضعیت خریدار',
  BUYER_SUSPENDED: 'تعلیق خریدار',
  BUYER_UPDATED: 'ویرایش خریدار',
  BUYER_WEBAUTHN_ALL_CREDENTIALS_REVOKED: 'لغو همهٔ کلیدهای ورود خریدار',
  BUYER_WEBAUTHN_CREDENTIAL_REGISTERED: 'ثبت کلید ورود خریدار',
  BUYER_WEBAUTHN_CREDENTIAL_REVOKED: 'لغو کلید ورود خریدار',
  CONFIRMATION_CODE_REJECTED: 'رد کد خرید',
  CONFIRMATION_CODE_RESEND_REQUESTED: 'درخواست ارسال دوبارهٔ کد خرید',
  CONFIRMATION_CODE_SENT: 'ارسال کد خرید',
  CREDIT_ALLOCATION_STATUS_CHANGED: 'تغییر وضعیت تخصیص اعتبار',
  CREDIT_PROGRAM_ACTIVATED: 'فعال‌سازی برنامهٔ اعتبار',
  CREDIT_PROGRAM_CLOSED: 'بستن برنامهٔ اعتبار',
  CREDIT_PROGRAM_CREATED: 'ساخت برنامهٔ اعتبار',
  CREDIT_PROGRAM_RETURNED_TO_DRAFT: 'بازگشت برنامه به پیش‌نویس',
  CREDIT_PROGRAM_REVISION_CREATED: 'نسخهٔ جدید برنامهٔ اعتبار',
  CREDIT_PROGRAM_SUPERSEDED: 'جایگزینی برنامهٔ اعتبار',
  CREDIT_PROGRAM_TARGETING_RUN_CREATED: 'ثبت تخصیص اعتبار',
  CREDIT_PROGRAM_TARGETING_RUN_EXECUTION_REQUESTED: 'درخواست اجرای تخصیص اعتبار',
  CREDIT_PROGRAM_TARGETING_RUN_REJECTED: 'رد تخصیص اعتبار',
  CREDIT_PROGRAM_UPDATED: 'ویرایش برنامهٔ اعتبار',
  DIRECT_ACTION_EXECUTED: 'اجرای مستقیم',
  ENROLLMENT_MEMBER_FAILED: 'خطا در ثبت‌نام عضو',
  ENROLLMENT_MEMBER_PROVISIONED: 'ثبت‌نام عضو',
  ENROLLMENT_REQUEST_CANCELLED: 'لغو ثبت‌نام گروهی',
  ENROLLMENT_REQUEST_COMPLETED: 'پایان ثبت‌نام گروهی',
  ENROLLMENT_REQUEST_CREATED: 'ثبت‌نام گروهی جدید',
  ENROLLMENT_REQUEST_MEMBERS_APPENDED: 'افزودن اعضا به ثبت‌نام گروهی',
  ENROLLMENT_REQUEST_MEMBER_UPDATED: 'ویرایش عضو ثبت‌نام گروهی',
  ENROLLMENT_REQUEST_PROVISIONING_REQUESTED: 'درخواست اجرای ثبت‌نام گروهی',
  ENROLLMENT_REQUEST_VALIDATED: 'بررسی ثبت‌نام گروهی',
  FINANCIAL_ADJUSTMENT_POSTED: 'ثبت اصلاح مالی',
  GUARANTEE_AGREEMENT_ACCEPTED: 'پذیرش توافق‌نامهٔ ضمانت',
  GUARANTEE_AGREEMENT_PUBLISHED: 'انتشار توافق‌نامهٔ ضمانت',
  GUARANTEE_RELATIONSHIP_CREATED: 'ثبت ضمانت',
  GUARANTOR_NOTIFICATION_REQUESTED: 'اطلاع‌رسانی به ضامن',
  GUARANTOR_RESTRICTION_APPLIED: 'محدودیت ضامن',
  GUARANTOR_WITHDRAWN: 'انصراف ضامن',
  IDENTITY_DEACTIVATED: 'غیرفعال‌سازی کاربر',
  IDENTITY_DEACTIVATION_REQUESTED: 'درخواست غیرفعال‌سازی کاربر',
  IDENTITY_KEYCLOAK_DISABLED: 'غیرفعال‌سازی ورود کاربر',
  IDENTITY_KEYCLOAK_MOBILE_UPDATED: 'به‌روزرسانی موبایل ورود',
  IDENTITY_KEYCLOAK_ROLES_REVOKED: 'لغو نقش‌های ورود',
  IDENTITY_LOGIN_LOCK_CLEARED: 'رفع قفل ورود',
  IDENTITY_LOGIN_LOCK_CLEAR_REQUESTED: 'درخواست رفع قفل ورود',
  IDENTITY_MOBILE_CHANGED: 'تغییر شماره موبایل',
  IDENTITY_PROVISIONED: 'ساخت حساب ورود',
  IDENTITY_PROVISIONING_REQUESTED: 'درخواست ساخت حساب ورود',
  IDENTITY_REALM_ROLES_ASSIGNMENT_REQUESTED: 'درخواست دادن نقش ورود',
  IDENTITY_ROLE_REVOCATION_REQUESTED: 'درخواست لغو نقش ورود',
  INSTALLMENT_PLAN_SET_REPLACED: 'تغییر طرح اقساطی',
  LOGIN_LOCK_CLEARED: 'رفع قفل ورود',
  MERCHANT_ACTIVATED: 'فعال‌سازی فروشگاه',
  MERCHANT_BRANCH_CREATED: 'افزودن شعبه',
  MERCHANT_BRANCH_UPDATED: 'ویرایش شعبه',
  MERCHANT_CAPACITY_CHANGED: 'تغییر ظرفیت فروشگاه',
  MERCHANT_CATEGORY_CREATED: 'ساخت دسته‌بندی',
  MERCHANT_CLOSED: 'بستن فروشگاه',
  MERCHANT_COMMERCIAL_SETTING_CHANGED: 'تغییر تنظیمات تجاری',
  MERCHANT_CONFIRMATION_MODE_CHANGED: 'تغییر روش تأیید خرید',
  MERCHANT_KYC_LOCKED: 'قفل اطلاعات هویتی فروشگاه',
  MERCHANT_KYC_VERIFIED: 'تأیید هویت فروشگاه',
  MERCHANT_REACTIVATED: 'فعال‌سازی دوبارهٔ فروشگاه',
  MERCHANT_REGISTERED: 'ثبت فروشگاه',
  MERCHANT_SUSPENDED: 'تعلیق فروشگاه',
  MERCHANT_UPDATED: 'ویرایش فروشگاه',
  MERCHANT_USER_DISABLED: 'غیرفعال‌سازی کاربر فروشگاه',
  MERCHANT_USER_INVITED: 'دعوت کاربر فروشگاه',
  MERCHANT_USER_UPDATED: 'ویرایش کاربر فروشگاه',
  ORGANIZATION_CREATED: 'ساخت سازمان',
  ORGANIZATION_ENROLLMENT_PROVISIONING_REQUESTED: 'درخواست ثبت‌نام اعضای سازمان',
  ORGANIZATION_MEMBERSHIP_CREATED: 'افزودن عضو سازمان',
  ORGANIZATION_MEMBERSHIP_UPDATED: 'ویرایش عضو سازمان',
  ORGANIZATION_ROLE_CREATED: 'ساخت نقش سازمانی',
  ORGANIZATION_UPDATED: 'ویرایش سازمان',
  PAYOUT_ACCOUNT_CHANGE_REQUESTED: 'درخواست تغییر حساب تسویه',
  PAYOUT_ACCOUNT_CHANGE_REQUEST_APPLIED: 'اعمال تغییر حساب تسویه',
  PAYOUT_ACCOUNT_CHANGE_REQUEST_REJECTED: 'رد تغییر حساب تسویه',
  PAYOUT_ACCOUNT_CREATED: 'ثبت حساب تسویه',
  PAYOUT_ACCOUNT_REJECTED: 'رد حساب تسویه',
  PAYOUT_ACCOUNT_VERIFIED: 'تأیید حساب تسویه',
  PLATFORM_ROLE_ASSIGNED: 'دادن نقش پلتفرم',
  PLATFORM_ROLE_GRANT_REQUESTED: 'درخواست دادن نقش پلتفرم',
  PLATFORM_ROLE_REVOKED: 'لغو نقش پلتفرم',
  POLICY_VERSION_CREATED: 'نسخهٔ جدید سیاست',
  PURCHASE_RESERVATION_EXPIRED: 'انقضای رزرو خرید',
  QR_TOKEN_CREATED: 'ساخت QR خرید',
  QR_TOKEN_INVALIDATED: 'ابطال QR خرید',
  REFERRAL_CODE_CREATED: 'ساخت کد معرف',
  REFERRAL_CODE_EXPIRED: 'انقضای کد معرف',
  REFERRAL_CODE_REVOKED: 'لغو کد معرف',
  SALE_BUYER_ASSOCIATED: 'اتصال خریدار به فروش',
  SALE_CANCELLED: 'لغو فروش',
  SALE_CONFIRMATION_FAILED: 'ناموفق در تأیید خرید',
  SALE_CONFIRMED: 'تأیید فروش',
  SALE_DRAFT_CREATED: 'ثبت پیش‌نویس فروش',
  SALE_DRAFT_EXPIRED: 'انقضای پیش‌نویس فروش',
  SALE_DRAFT_UPDATED: 'ویرایش پیش‌نویس فروش',
  SALE_REJECTED: 'رد فروش',
  SALE_SUBMITTED: 'ارسال فروش برای تأیید',
};

export function auditActionLabel(action: string): string {
  return AUDIT_ACTION_LABELS[action] ?? 'رویداد ثبت‌شده';
}
